import React, { useEffect } from "react";

const CommunityGuidelines = () => {
    useEffect(() => {
        document.title = "Community Guidelines - CGES.CLUB";
    }, []);

    return (
        <>
            <div className="breadcrumb-area policy-breadcrumb">
                <div className="container">
                    <div className="breadcrumb-inner">
                        <h2 className="page-title policy-page-title">Community <span>Guidelines</span></h2>
                        <ul className="page-list">
                            <li className="policy-effective-date">EFFECTIVE MAR 24, 2026</li>
                        </ul>
                    </div>
                </div>
            </div>

            <div className="blog-area pd-top-60 policy-page">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="blog-details-page-content">
                                <div className="single-blog-inner style-large">
                                    <div className="details p-0 policy-content">
                                        <p>
                                            CGES.CLUB is built for players, creators, students, communities, and partners who want a
                                            competitive space that stays respectful, safe, and welcoming. These Community Guidelines
                                            explain the standards we expect when you use our platform, join events, publish content,
                                            interact with others, or represent the CGES.CLUB community.
                                        </p>

                                        <br />
                                        <h4 className="title">1. Respect Other Members</h4>
                                        <p>
                                            Treat everyone with basic respect. Healthy rivalry, criticism, and debate are fine, but
                                            harassment, bullying, hate speech, intimidation, personal attacks, stalking, or targeted
                                            abuse are not allowed.
                                        </p>
                                        <ul>
                                            <li>Do not insult, threaten, or humiliate other users.</li>
                                            <li>Do not target people based on identity, religion, caste, gender, nationality, or disability.</li>
                                            <li>Do not encourage pile-ons, brigading, or mass harassment.</li>
                                        </ul>

                                        <br />
                                        <h4 className="title">2. Keep Content Safe and Appropriate</h4>
                                        <p>
                                            Content shared on CGES.CLUB should be relevant to the community and suitable for a general
                                            gaming and esports audience. Do not post or upload content that is unlawful, sexually
                                            explicit, exploitative, graphically violent, deceptive, or intentionally disturbing.
                                        </p>
                                        <ul>
                                            <li>Do not share pornography or exploitative content.</li>
                                            <li>Do not post graphic violence or self-harm promotion.</li>
                                            <li>Do not upload malware, suspicious files, or harmful links.</li>
                                        </ul>

                                        <br />
                                        <h4 className="title">3. No Cheating, Fraud, or Manipulation</h4>
                                        <p>
                                            Fair competition matters. Users must not cheat in tournaments, manipulate leaderboards,
                                            exploit bugs, create fake engagement, or attempt to gain access to benefits, rewards, or
                                            accounts through dishonest means.
                                        </p>
                                        <ul>
                                            <li>Do not use hacks, bots, scripts, exploits, or unauthorized tools.</li>
                                            <li>Do not impersonate another user, organizer, creator, or staff member.</li>
                                            <li>Do not submit false information for registrations, payouts, or participation records.</li>
                                        </ul>

                                        <br />
                                        <h4 className="title">4. Protect Privacy and Personal Data</h4>
                                        <p>
                                            Respect your own privacy and the privacy of others. Never share someone else&apos;s personal
                                            information without permission, including phone numbers, email addresses, payment details,
                                            private documents, or location information.
                                        </p>
                                        <p>
                                            If you believe private information has been exposed on the platform, contact us promptly so
                                            we can review and remove it where appropriate.
                                        </p>

                                        <br />
                                        <h4 className="title">5. Use Community Features Responsibly</h4>
                                        <p>
                                            Messages, comments, profiles, submissions, support requests, and creator tools should be
                                            used for legitimate participation in the platform. Spam, repetitive promotion, misleading
                                            posts, and unrelated advertising may be removed.
                                        </p>
                                        <ul>
                                            <li>Do not send repeated unsolicited messages or promotions.</li>
                                            <li>Do not misuse support channels for abuse or non-genuine reports.</li>
                                            <li>Do not post clickbait, scams, or deceptive offers.</li>
                                        </ul>

                                        <br />
                                        <h4 className="title">6. Respect Intellectual Property</h4>
                                        <p>
                                            Only share content you own or have permission to use. Do not upload stolen artwork,
                                            copied writing, pirated assets, unauthorized recordings, or branded material that infringes
                                            on another person&apos;s intellectual property rights.
                                        </p>

                                        <br />
                                        <h4 className="title">7. Event and Competition Conduct</h4>
                                        <p>
                                            If you join tournaments, game jams, creator activities, or official campaigns, you must
                                            follow the rules provided for that event in addition to these guidelines. Unsportsmanlike
                                            conduct, match-fixing, account sharing, or abusing organizers, judges, or opponents may lead
                                            to disqualification and further account action.
                                        </p>

                                        <br />
                                        <h4 className="title">8. Enforcement and Actions</h4>
                                        <p>
                                            We may review accounts, content, or activity when we receive reports or detect behavior
                                            that appears to violate these guidelines, our policies, or applicable law. Depending on the
                                            severity or repeat nature of the issue, we may take action such as:
                                        </p>
                                        <ul>
                                            <li>Removing content or limiting visibility</li>
                                            <li>Issuing warnings</li>
                                            <li>Suspending features, event access, or account privileges</li>
                                            <li>Disqualifying users from competitions or campaigns</li>
                                            <li>Permanently restricting or terminating accounts</li>
                                        </ul>

                                        <br />
                                        <h4 className="title">9. Reporting Violations</h4>
                                        <p>
                                            If you see behavior that violates these Community Guidelines, please report it through the
                                            appropriate platform channel or contact our team. Clear reports with screenshots, links, and
                                            relevant details help us investigate more effectively.
                                        </p>

                                        <br />
                                        <h4 className="title">10. Updates to These Guidelines</h4>
                                        <p>
                                            We may update these Community Guidelines from time to time to reflect platform changes,
                                            safety requirements, or legal obligations. Continued use of CGES.CLUB after an update means
                                            you accept the revised version.
                                        </p>

                                        <br />
                                        <h4 className="title">11. Contact Us</h4>
                                        <p>
                                            If you have questions about these Community Guidelines or need to report a serious safety
                                            concern, contact us at <a href="mailto:support@cges.club" className="color-base">info@cges.club</a>.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default CommunityGuidelines;
